import Vue from "vue";
import store from "@/store";
import i18n from "@/plugins/i18n.js";
const checkoutValidator = {
  install(Vue) {
    Vue.prototype.$checkoutValidator = {
      minOrderAmount: function () {
        if (store.getters.cartDetails) {
          if (
            store.getters.cartDetails.subTotal <
              store.getters.storeInfo.configs.minDeliveryAmount &&
            store.getters.deliveryMethod === "delivery-service"
          ) {
            store.dispatch("checkout/setValidationMinOrderAmount", {
              status: false,
              message: i18n.t("checkout.min_delivery", {
                amount: Vue.prototype.$appFormatters.formatMoney(
                  store.getters.storeInfo.configs.minDeliveryAmount
                ),
              }),
            });
            return false;
          } else {
            if (store.getters.storeInfo.configs.minPickupAmount) {
              if (
                store.getters.cartDetails.subTotal <
                  store.getters.storeInfo.configs.minPickupAmount &&
                store.getters.deliveryMethod === "pickup-service"
              ) {
                store.dispatch("checkout/setValidationMinOrderAmount", {
                  status: false,
                  message: i18n.t("checkout.min_pickup", {
                    amount: Vue.prototype.$appFormatters.formatMoney(
                      store.getters.storeInfo.configs.minDeliveryAmount
                    ),
                  }),
                });
                return false;
              } else {
                store.dispatch("checkout/setValidationMinOrderAmount", {
                  status: true,
                  message: "",
                });
                return true;
              }
            } else {
              store.dispatch("checkout/setValidationMinOrderAmount", {
                status: true,
                message: "",
              });
              return true;
            }
          }
        }
      },
      customerInfo: function () {
        if (store.getters.customerOption === 0) {
          if (store.getters.guestInfo) {
            store.dispatch("checkout/setValidationUserInfo", {
              status: true,
              message: "",
            });
            return true;
          } else {
            store.dispatch("checkout/setValidationUserInfo", {
              status: false,
              message: i18n.t("checkout.we_need_some_info_about_you"),
            });
            return false;
          }
        } else {
          if (store.getters.checkAuth) {
            store.dispatch("checkout/setValidationUserInfo", {
              status: true,
              message: "",
            });
            return true;
          } else {
            store.dispatch("checkout/setValidationUserInfo", {
              status: false,
              message: i18n.t("checkout.we_need_you_do_login"),
            });
            return false;
          }
        }
      },
      deliveryInfo: function () {
        if (store.getters.deliveryServicesList.length > 0) {
          if (store.getters.deliveryMethod === "delivery-service") {
            if (store.getters.guestAddress) {
              store.dispatch("checkout/setValidationDeliveryInfo", {
                status: true,
                message: "",
              });
              return true;
            } else {
              store.dispatch("checkout/setValidationDeliveryInfo", {
                status: false,
                message: i18n.t("checkout.AddressDeliveryZone"),
                // message:
                //   store.getters.nonDeliverableError ===
                //   "DROPOFF_OUTSIDE_OF_DELIVERY_AREA"
                //     ? i18n.t("checkout.AddressDeliveryZone")
                //     : i18n.t("checkout.AddressDeliveryGeneric"),
              });
              return false;
            }
          } else {
            store.dispatch("checkout/setValidationDeliveryInfo", {
              status: true,
              message: "",
            });
            return true;
          }
        }
      },
      deliveryWhen: function () {
        if (store.getters.deliveryIsAsap) {
          // For ASAP orders, check if products require specific pickup dates
          const cartItems = store.getters.cartDetails?.items || [];
          const productsRequireDates = cartItems.some(
            (item) => item.productRequiredPickupDateFrom
          );

          if (productsRequireDates) {
            store.dispatch("checkout/setValidationDeliveryWhen", {
              status: false,
              message: i18n.t("checkout.products_require_specific_date"),
            });
            return false;
          }

          store.dispatch("checkout/setValidationDeliveryWhen", {
            status: true,
            message: "",
          });
          return true;
        } else {
          if (store.getters.deliveryDropoffDateTime) {
            if (
              store.getters.nonDeliverableReason &&
              store.getters.nonDeliverableReason === "schedule-time"
            ) {
              store.dispatch("checkout/setValidationDeliveryWhen", {
                status: false,
                message: i18n.t("checkout.AddressScheduleTime"),
              });
              return false;
            }

            // Validate pickup date against product requirements
            const cartItems = store.getters.cartDetails?.items || [];
            const selectedDate = new Date(
              store.getters.deliveryDropoffDateTime
            );
            selectedDate.setHours(0, 0, 0, 0);

            // Check if all products have the same date requirements
            const dateRanges = cartItems
              .filter((item) => item.productRequiredPickupDateFrom)
              .map((item) => ({
                from: new Date(item.productRequiredPickupDateFrom),
                to: new Date(item.productRequiredPickupDateTo),
              }));

            if (dateRanges.length > 0) {
              // Check if all products require the same date range
              const uniqueRanges = dateRanges.filter(
                (range, index, self) =>
                  index ===
                  self.findIndex(
                    (r) =>
                      r.from.getTime() === range.from.getTime() &&
                      r.to.getTime() === range.to.getTime()
                  )
              );

              if (uniqueRanges.length > 1) {
                store.dispatch("checkout/setValidationDeliveryWhen", {
                  status: false,
                  message: i18n.t("checkout.products_require_different_dates"),
                });
                return false;
              }

              // Check if selected date is within the required range
              const requiredRange = uniqueRanges[0];
              if (
                selectedDate < requiredRange.from ||
                selectedDate > requiredRange.to
              ) {
                const fromDate = requiredRange.from.toLocaleDateString(
                  i18n.locale === "dk" ? "da-DK" : "en-US",
                  {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  }
                );
                const toDate = requiredRange.to.toLocaleDateString(
                  i18n.locale === "dk" ? "da-DK" : "en-US",
                  {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  }
                );
                store.dispatch("checkout/setValidationDeliveryWhen", {
                  status: false,
                  message: i18n.t("checkout.date_outside_required_range", {
                    from: fromDate,
                    to: toDate,
                  }),
                });
                return false;
              }
            }

            store.dispatch("checkout/setValidationDeliveryWhen", {
              status: true,
              message: "",
            });
            return true;
          } else {
            store.dispatch("checkout/setValidationDeliveryWhen", {
              status: false,
              message: i18n.t("checkout.we_need_when_option"),
            });
            return false;
          }
        }
      },
      paymentInfo: function (valid = false) {
        if (store.getters.total === 0) {
          store.dispatch("checkout/setValidationPaymentInfo", {
            status: true,
            message: "",
          });
        } else {
          if (store.getters.paymentType === "online-payment") {
            if (
              !store.getters.checkAuth &&
              store.getters.appInfo.paymentProvider === "flatpay"
            ) {
              store.dispatch("checkout/setValidationPaymentInfo", {
                status: true,
                message: "",
              });
              return true;
            }
            if (valid) {
              store.dispatch("checkout/setValidationPaymentInfo", {
                status: true,
                message: "",
              });
              return true;
            } else {
              store.dispatch("checkout/setValidationPaymentInfo", {
                status: false,
                message: i18n.t("checkout.we_need_fill_payment"),
              });
              return false;
            }
          } else {
            store.dispatch("checkout/setValidationPaymentInfo", {
              status: true,
              message: "",
            });
          }
        }
      },
      promoCode: function (data) {
        store.dispatch("checkout/setValidationPromoCode", data);
        return data;
      },
    };
  },
};
Vue.use(checkoutValidator);
